export const CONTACT = {
  name: "Lars Odeling",
  phone: "070-575 14 83",
  phoneHref: "tel:+46705751483",
  email: "lars@folkarebygg.se",
  emailHref: "mailto:lars@folkarebygg.se",
  orgNumber: "570212-1913",
  dorunner: "https://www.dorunner.se/f%C3%B6retag/folkare-bygg-31611",
};

export const NAV = [
  { id: "tjanster", label: "Tjänster" },
  { id: "projekt", label: "Projekt" },
  { id: "om", label: "Om Folkare Bygg" },
  { id: "kontakt", label: "Kontakt" },
];
